import { render, staticRenderFns } from "./FixedJournalPanel.vue?vue&type=template&id=61e13a11&scoped=true&"
import script from "./FixedJournalPanel.vue?vue&type=script&lang=js&"
export * from "./FixedJournalPanel.vue?vue&type=script&lang=js&"
import style0 from "./FixedJournalPanel.vue?vue&type=style&index=0&id=61e13a11&prod&lang=less&"
import style1 from "./FixedJournalPanel.vue?vue&type=style&index=1&id=61e13a11&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e13a11",
  null
  
)

export default component.exports